import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function AdminLogin() {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const { adminLogin, settings } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await adminLogin(phone, password);
      if (user.role === 'admin') {
        toast.success('Welcome, Admin! 🛡️');
        // Use navigate instead of window.location so React Router handles it
        navigate('/admin', { replace: true });
      } else {
        toast.error('Not an admin account');
      }
    } catch (err) {
      toast.error(err.response?.data?.error || 'Invalid credentials');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', padding:20, background:'radial-gradient(ellipse at 50% 20%, rgba(239,68,68,0.15) 0%, transparent 60%), var(--bg)' }}>
      <div style={{ width:'100%', maxWidth:400 }}>
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <div style={{ fontSize:48, marginBottom:8 }}>🛡️</div>
          <h1 style={{ fontSize:26, fontWeight:800, color:'#f87171' }}>Admin Portal</h1>
          <p style={{ color:'var(--text2)', fontSize:13 }}>{settings.brand_name || 'Oexams'} — Restricted Access</p>
        </div>
        <div className="card" style={{ borderColor:'rgba(239,68,68,0.3)' }}>
          <h2 style={{ fontSize:20, fontWeight:700, marginBottom:20, textAlign:'center' }}>🔐 Admin Sign In</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Admin Phone</label>
              <input
                type="tel"
                value={phone}
                onChange={e => setPhone(e.target.value)}
                placeholder="Admin phone number"
                required
                autoComplete="off"
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <div style={{ position:'relative' }}>
                <input
                  type={showPw ? 'text' : 'password'}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Admin password"
                  required
                  style={{ paddingRight:44 }}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  onClick={() => setShowPw(v => !v)}
                  style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'var(--text2)', fontSize:18, lineHeight:1 }}
                >
                  {showPw ? '🙈' : '👁️'}
                </button>
              </div>
            </div>
            <button
              type="submit"
              disabled={loading}
              style={{ width:'100%', background:'#ef4444', color:'white', border:'none', borderRadius:10, fontSize:15, fontWeight:700, cursor:loading?'not-allowed':'pointer', padding:'14px 20px', display:'flex', alignItems:'center', justifyContent:'center', gap:8, opacity:loading?0.7:1 }}
            >
              {loading ? '⏳ Signing in...' : '🛡️ Admin Login'}
            </button>
          </form>
          <p style={{ textAlign:'center', marginTop:16, fontSize:12, color:'var(--text3)' }}>
            Not admin? <a href="/#/login" style={{ color:'var(--primary-light)' }}>Regular login</a>
          </p>
        </div>
      </div>
    </div>
  );
}
